module.exports = __webpack_public_path__ + "img/file-arrow-down.d203c295.svg";